import React from 'react';

const RightArrow = ({ className = '', ...props }) => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={` ${className}`} {...props}>
  <path d="M18.3645 8.05013L17.6575 7.34313C16.3185 6.00382 14.5477 5.18298 12.6603 5.02666C10.7729 4.87034 8.89126 5.38868 7.35015 6.48946C5.80904 7.59024 4.70842 9.20205 4.24414 11.0381C3.77985 12.8742 3.98199 14.8154 4.81461 16.5165C5.64723 18.2175 7.05632 19.568 8.79116 20.3276C10.526 21.0873 12.4741 21.2068 14.2888 20.665C16.1035 20.1231 17.6671 18.9551 18.7015 17.3686C19.7358 15.7822 20.1738 13.8802 19.9375 12.0011M18.3645 8.05013L14.1215 8.05113M18.3645 8.05013V3.80713" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
};

export default RightArrow;
